import React from 'react';
import { useTranslation } from 'react-i18next';

import Dropdown from '@common/components/dropdown';

import type { LooseObject } from '@common/types/util-types';
import { QuestionIcon } from '../question-icon/question-icon';
import { PerformanceQuestionType } from '@modules/performance/definitions';
import './question-list.scss';

const getOptions = () => ({
  [PerformanceQuestionType.OPEN_QUESTION]: {
    type: PerformanceQuestionType.OPEN_QUESTION,
  },
  [PerformanceQuestionType.COMPETENCIES]: {
    type: PerformanceQuestionType.COMPETENCIES,
  },
  [PerformanceQuestionType.CONTENT_MODULE]: {
    type: PerformanceQuestionType.CONTENT_MODULE,
  },
  [PerformanceQuestionType.SLIDER]: {
    type: PerformanceQuestionType.SLIDER,
  },
  [PerformanceQuestionType.TALENT_REVIEW]: {
    type: PerformanceQuestionType.TALENT_REVIEW,
  },
});

type Props = {
  enabledComponents: (keyof ReturnType<typeof getOptions>)[];
  toggle?: React.ReactNode;
  onSelect: (item?: LooseObject<{ type: string }>) => void;
  disabled?: boolean;
  disabledComponents?: (keyof ReturnType<typeof getOptions>)[];
};

export const QuestionDropdown = ({
  enabledComponents,
  toggle,
  onSelect,
  disabled = false,
  disabledComponents = [],
}: Props) => {
  const { t } = useTranslation();

  return (
    <Dropdown className="CreateQuestion" toggle={toggle}>
      <h3>{t('performance:choose_question_type')}</h3>
      {enabledComponents.map((type) => {
        const isDisabled = disabled || disabledComponents.includes(type);
        return (
          <Dropdown.Item
            key={type}
            disabled={isDisabled}
            className="CreateQuestion__Item"
            onClick={() => !isDisabled && onSelect(getOptions()[type])}
          >
            <QuestionIcon type={type} className="!tw-self-center" />
            <h5>{t('performance:question_type_title', { context: type })}</h5>
          </Dropdown.Item>
        );
      })}
    </Dropdown>
  );
};
